import { FaqBurger, FaqQuestion, Radio } from 'app/assets/icons'
import { Layout } from 'app/common/layout'
import { useEffect } from 'react'
import { useIntl } from 'react-intl'
import type { RestaurantVeryShortDTO } from 'shared/store/store-locator'
import type { SatisfactionForm as FormType } from 'shared/types'
import { SatisfactionForm } from './form'
import {
    StyledBlock,
    StyledBurgerIconContainer,
    StyledContainer,
    StyledContent,
    StyledDescription,
    StyledForm,
    StyledHeader,
    StyledQuestionIconContainer,
    StyledSuccess,
    StyledText,
    StyledTitle
} from './styles'
import type { MappedRestaurant } from './types'
import React from 'react'

type SatisfactionComponentProps = {
    restaurants: RestaurantVeryShortDTO[],
    restaurantFromUrl: RestaurantVeryShortDTO,
    sendFormSuccess: boolean,
    sendFormError: any,
    sendForm: (data: FormType) => void,
    searchAll: () => Promise<any>
}

export const SatisfactionComponent = ({
    restaurants,
    restaurantFromUrl,
    sendFormSuccess,
    sendFormError,
    sendForm,
    searchAll
}: SatisfactionComponentProps) => {
    const intl = useIntl()

    const mapRestaurant = (
        restaurant: RestaurantVeryShortDTO
    ): MappedRestaurant => ({
        value: restaurant.id,
        label: restaurant.name
    })

    const mapRestaurants = (restaurants: RestaurantVeryShortDTO[]) =>
        restaurants.map(mapRestaurant)

    useEffect(() => {
        searchAll()
    }, [])

    return (
        <Layout background="plain" border>
            <StyledContainer>
                <StyledContent>
                    <StyledTitle center color="white">
                        {intl.formatMessage({ id: 'satisfaction.form.title' })}
                    </StyledTitle>
                    <StyledBlock>
                        {sendFormSuccess ? (
                            <StyledSuccess>
                                <Radio
                                    color="green"
                                    size={40}
                                    style={{ margin: 10 }}
                                />
                                <StyledText>
                                    {intl.formatMessage({
                                        id: 'satisfaction.form.success'
                                    })}
                                </StyledText>
                            </StyledSuccess>
                        ) : (
                            <>
                                <StyledDescription>
                                    {intl.formatMessage({
                                        id: 'satisfaction.form.description'
                                    })}
                                </StyledDescription>
                                <StyledForm>
                                    <SatisfactionForm
                                        restaurants={
                                            restaurants &&
                                            mapRestaurants(restaurants)
                                        }
                                        restaurantFromUrl={
                                            restaurantFromUrl &&
                                            mapRestaurant(restaurantFromUrl)
                                        }
                                        sendForm={sendForm}
                                        error={sendFormError}
                                    />
                                </StyledForm>
                            </>
                        )}
                    </StyledBlock>
                </StyledContent>
                <StyledHeader>
                    <StyledBurgerIconContainer>
                        <FaqBurger />
                    </StyledBurgerIconContainer>
                    <StyledQuestionIconContainer>
                        <FaqQuestion />
                    </StyledQuestionIconContainer>
                </StyledHeader>
            </StyledContainer>
        </Layout>
    )
}
